import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { default as minifyCssString } from 'minify-css-string'

class foot extends Component {
    componentDidMount() {}
    render() {
    		const cssString = `
        #mmg{
                    max-width: 83%;
    margin-bottom: 35px;
        }
          #pg {
    font-size: 17px;
 }
          .obb{
        margin: 0 5%;
    font-family: mor;
    color: #fff;
        font-size: 13px;
    letter-spacing: 0.5px;
  }
   #lok{
      padding-top: 0 !important;
      margin-top:  0 !important;
    }
.App{
	text-align: center;
}

@media (max-width: 992px) {
         .obb{
       font-size: 7px;
  }
  #pg {
    font-size: 15px;
 }

.trans{

}
}
@media (max-width: 768px) {
  #pg {
    font-size: 11px;
  }
  .trans {
    font-size: 16px !important;
    padding: 7px !important;
  }
     #mmg{
    max-width: 96%;
     margin-bottom: 25px;
        }
        .obb {
    font-size: 8px;
}
}

`
        return (

            <div>
                          <style dangerouslySetInnerHTML={{__html: minifyCssString(cssString) }} /> 

                 <footer className="site-footer border-top">
        <div className="container">
           
            <div id="lok" className="row pt-5 mt-5 text-center">
        <ul className="sosb">
                
                    
                <li><a className="tsos" target="_blank" href="https://www.instagram.com/cikoleforestrun/"><span id="pg" className="icon-instagram ssa trans"></span></a></li>
                <li><span id="pg" className="icon-twitter ssa trans"></span></li>
                <li><a className="tsos saa" target="_blank" href="https://
www.facebook.com/Cikole-Forest-Run-427770087794121/?_rdc=1&_rdr"><span id="pg" className="icon-facebook-f trans"></span></a></li>
              </ul>
                <div className="col-md-12">
       
            <img id="mmg"  className="thumb-image loaded" src="/images/sponsor_0524687309.png" />

   
                   <div className="obb">Copyright ©2O19 by Cikole Forest Run. All rights reserved.</div>
                </div>
            </div>
        </div>
    </footer>
      </div>

        );
    }
}
export default foot;